'use client';

import { memo } from 'react';

import { GeneralLibraryHeaderCreateButton } from '~/components/LibraryBeta/GeneralLibraryPage/GeneralLibraryHeaderCreateButton';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';

export const GeneralLibraryTopBarAddButton = memo(() => {
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();

  return (
    <GeneralLibraryHeaderCreateButton
      data-testid="GENERAL_LIBRARY_HEADER_ADD_BOARD_BUTTON"
      workspacePermissions={workspacePermissions}
    />
  );
});

GeneralLibraryTopBarAddButton.displayName = 'GeneralLibraryTopBarAddButton';
